import Badge from '@mui/material/Badge';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSiteContext } from '../../context/useSiteContext';
import { MobileVideoStatus } from '../../modules/commonTypes';
import messages from './messages';

const styles = {
  badge: {
    '& .MuiBadge-badge': {
      backgroundColor: 'success.main',
      zIndex: 'auto',
    },
    cursor: 'pointer',
    display: 'inline-block',
  },
  paper: {
    padding: 1,
  },
  title: {
    fontWeight: 'bold',
  },
  tooltip: {
    backgroundColor: 'transparent',
    maxWidth: '160px',
  },
};

export interface IDeviceForFreeTooltipProps {
  children: React.JSX.Element;
  isTooltip: boolean;
  status: string;
}

function DeviceForFreeTooltip({ children, isTooltip, status }: IDeviceForFreeTooltipProps) {
  const isPaymentModelPerApartment = useSiteContext().hasSiteBillingType('PER_APARTMENT');

  return isTooltip &&
    (status === MobileVideoStatus.STANDARD ||
      status === MobileVideoStatus.TRIAL_ACTIVE ||
      status === MobileVideoStatus.TEMPORARY) ? (
    <Tooltip
      placement="right-start"
      slotProps={{
        tooltip: {
          sx: styles.tooltip,
        },
      }}
      title={
        <Paper sx={styles.paper}>
          <Typography color="primary" sx={styles.title} variant="body2">
            <FormattedMessage {...messages.deviceForFreeTooltipFree} />
          </Typography>
          <Typography color="secondary" variant="caption">
            <FormattedMessage
              {...(isPaymentModelPerApartment
                ? messages.deviceForFreeTooltipApartmentsFree
                : messages.deviceForFreeTooltipDevicesFree)}
            />
          </Typography>
        </Paper>
      }
    >
      <Badge sx={styles.badge} variant="dot">
        {children}
      </Badge>
    </Tooltip>
  ) : (
    children
  );
}

export default DeviceForFreeTooltip;
